/** @format */

export function getBilling(field) {
  try {
    return field ? this.state?.billing[field] || null : this.state.billing;
  } catch (e) {
    return field ? false : null;
  }
}
